// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.md-ft {\n  height: 94vh;\n}\n.md-ft .container-fluid,\n.md-ft object {\n  height: 100%;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
